module.exports = __webpack_public_path__ + "img/right-arrow-grey.8192e78b.svg";